module.exports = __webpack_public_path__ + "media/images/edit-27ec406e0b4ccd1bb499a0432c66afe2.svg";